/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded File Upload (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_FILE_UPLOAD_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 88C0.5 39.3989 39.8989 0 88.5 0C137.101 0 176.5 39.3989 176.5 88V144C176.5 161.673 162.173 176 144.5 176H88.5C39.8989 176 0.5 136.601 0.5 88Z"
      fill="#F5F5F5"
    />
    <path
      clipRule="evenodd"
      d="M98.5097 105.483H78.5097C75.7597 105.483 73.5097 103.233 73.5097 100.483V75.4829H65.5597C61.1097 75.4829 58.9097 70.0829 62.0597 66.9329L85.0097 43.9829C85.9439 43.0467 87.2121 42.5205 88.5347 42.5205C89.8573 42.5205 91.1255 43.0467 92.0597 43.9829L115.01 66.9329C118.16 70.0829 115.91 75.4829 111.46 75.4829H103.51V100.483C103.51 103.233 101.26 105.483 98.5097 105.483ZM118.508 115.482H58.5078C55.7578 115.482 53.5078 117.732 53.5078 120.482C53.5078 123.232 55.7578 125.482 58.5078 125.482H118.508C121.258 125.482 123.508 123.232 123.508 120.482C123.508 117.732 121.258 115.482 118.508 115.482Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <circle cx="133" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132.503 107.833C119.138 107.833 108.336 118.636 108.336 132C108.336 145.364 119.138 156.166 132.503 156.166C145.867 156.166 156.669 145.364 156.669 132C156.669 118.636 145.867 107.833 132.503 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="138" />
  </svg>
);
